import { Component, OnInit, HostListener } from '@angular/core';

import { SpinnerService } from 'src/app/services/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  showContent = true;
  navigationMenuOpen = false;
  activeNavDropdown = -1;
  message: any = {};
  showNavMenu = true;
  cpid: string;
  isPaymentLinkPage = false;

  navApiUrl: any = environment.navApiUrl;

  constructor(
    private spinner: SpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  async ngOnInit() {
    const currentHref = window.location.href;
    if (currentHref.indexOf('corporate') > -1) {
      this.showNavMenu = false;
    }
  }

  onDropDownMenuClick(currentNav: number) {
    this.activeNavDropdown = currentNav;
  }

  toggleNavigationMenu() {
    this.navigationMenuOpen = !this.navigationMenuOpen;
  }

  changeLang(lang: string) {
    if (lang === 'hi') {
      localStorage.setItem('locale', 'hi');
    } else if (lang === 'en') {
      localStorage.setItem('locale', 'en');
    }
    window.location.assign('./');
  }

  redirect() {
    if (this.showNavMenu) {
      location.assign('https://www.iffcotokio.co.in/');
    } else if (this.cpid) {
      this.router.navigate(['../corporate/' + this.cpid]);
    }
  }

  @HostListener('click', ['$event']) onClick(event: any) {
    if (event.target.href === undefined || event.target.href === null
      || event.target.href instanceof Object) {
      event.preventDefault();
      return false;
    }
    const href = event.target.href.replace(event.target.baseURI, '');
    if (href.length > 1) {
      if (href !== 'https://www.iffcotokio.co.in/') {
        this.spinner.showSpinner();
      }
      this.toggleNavigationMenu();
    }
  }
}
